import React from 'react'
import {
  styled,
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@material-ui/core'
import {useOrganizationTypesState, useEditApplication} from 'lms/hooks'

const Content = styled('div')({
})

const Heading = styled('h4')(({theme}) => ({
  margin: 0,
  marginTop: 12,
  marginBottom: 6,
  fontSize: 18,
  fontWeight: 500,
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

const Grid = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

const FormControlLabel = styled(MuiFormControlLabel)({
})

const nameSorter = (a, b) => a.name.localeCompare(b.name)

const OrganizationTypes = (props) => {
  const [application, updateApplication] = useEditApplication()
  const {data} = useOrganizationTypesState()

  const appOrganizationTypes = application.organizationTypes || []
  const isSelected = id => appOrganizationTypes.includes(id)
  const createCheck = id => (
    <MuiCheckbox
      checked={isSelected(id)}
      onChange={(e, checked) => updateOrganizationTypes(id, checked)}
    />
  )

  const sortedOrganizationTypes = data.allIds.map(id => data.byId[id]).sort(nameSorter)

  const updateOrganizationTypes = (id, checked) => {
    const set = new Set(appOrganizationTypes)
    checked ? set.add(id) : set.delete(id)
    updateApplication({organizationTypes: Array.from(set)})
  }

  return (
    <Content {...props}>
      <Heading>Organization Type</Heading>
      <Grid>
        {sortedOrganizationTypes.map((orgType) => (
          <FormControlLabel
            key={orgType.id}
            label={orgType.name}
            control={createCheck(orgType.id)}
          />
        ))}
      </Grid>
    </Content>
  )
}

export default OrganizationTypes
